module.exports = __webpack_public_path__ + "assets/powerschool-logo-black-vertical.png?053cc90df63615f7f97283ce20e73fdb"